/* Happilystory — fiche "poster-naissance" (designs naissance données bébé).
   Pattern poster-grid allégé : canvas transparent par palette (alt canvas:<id>)
   + overlay 5 slots <text> (prenom, datecourte, heure, taille, poids) aux
   coordonnées PAR PRODUIT (metafield happilystory.naissance_config), palette =
   canvas + fond couplés, toggle garçon/fille (palette conseillée + placeholder).
   Print : worker shopify-to-gelato _hs_mode=grid inchangé. */
(function () {
  var CFG = window.HSP_CFG || {};
  var N = CFG.naissance || null;
  var root = document.querySelector('[data-section-id="' + CFG.sectionId + '"]');
  if (!root || !N || !Array.isArray(N.slots)) return;
  var form = root.querySelector('.hsp-form');
  if (!form) return;

  var WATERMARK_VARIANT_ID = 62562593964362;
  var WATERMARK_PRICE_CENTS = 299;

  var VARIANTS = CFG.variants || [];
  var CANVAS_BY_PALETTE = CFG.canvasByPalette || {};
  var PALETTES = {};
  (N.palettes || []).forEach(function (p) { PALETTES[p.id] = p; });
  var curPalette = (CFG.defaultPalette && PALETTES[CFG.defaultPalette]) ? CFG.defaultPalette
    : (N.defaultPalette && PALETTES[N.defaultPalette]) ? N.defaultPalette
    : (N.palettes && N.palettes[0] ? N.palettes[0].id : null);
  var INK = N.ink || '#4A3B3F';

  // Valeurs d'exemple des placeholders (mêmes que le design-lab / les héros).
  var SAMPLE = { prenom: 'Léo', datecourte: '12.03.2025', heure: '08h42', taille: '51 cm', poids: '3,240 kg', lieu: 'Paris', signe: 'Poissons' };
  var samplePrenom = SAMPLE.prenom;

  // Compensation optique de centrage : Caveat est une manuscrite PENCHÉE, ses
  // glyphes ne sont pas centrés dans leur avance. Un text-anchor="middle"
  // (qui centre l'avance, pas l'encre) pose donc le texte ~10 % de la taille
  // trop à DROITE — visible car le libellé cuit juste au-dessus est en
  // Quicksand, qui se centre parfaitement. On décale les textes Caveat.
  // Le x corrigé part tel quel dans _hs_grid : l'impression hérite du fix.
  var OPTICAL_DX_RATIO = { Caveat: -0.10 };
  function opticalDx(family, size) {
    var r = OPTICAL_DX_RATIO[family];
    return r ? Math.round(r * size) : 0;
  }

  // Le TTF print attend le family-name front ; textElGrid (worker) traduit déjà
  // Fredoka -> "Fredoka SemiBold", on envoie donc la clé front telle quelle.
  var CSS_FAMILY = {
    'Caveat': "'Caveat', cursive",
    'Quicksand': "'Quicksand', sans-serif",
    'Fredoka': "'Fredoka', sans-serif",
    'Pacifico': "'Pacifico', cursive",
    'Amatic SC': "'Amatic SC', cursive"
  };

  function lightenHex(hex, amount) {
    var m = /^#([0-9a-f]{6})$/i.exec(hex || '');
    if (!m) return '#b9b1a6';
    var n = parseInt(m[1], 16);
    var r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
    function h2(v) { return ('0' + v.toString(16)).slice(-2); }
    r = Math.round(r + (255 - r) * amount);
    g = Math.round(g + (255 - g) * amount);
    b = Math.round(b + (255 - b) * amount);
    return '#' + h2(r) + h2(g) + h2(b);
  }

  // ---------- Overlay : un <text> par slot ----------
  var overlay = root.querySelector('.hsp-overlay');
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var slotEls = {}; // key -> { el, def, fitted }
  N.slots.forEach(function (s) {
    var t = document.createElementNS(SVG_NS, 'text');
    t.setAttribute('x', s.x);
    t.setAttribute('y', s.y);
    t.setAttribute('text-anchor', s.anchor || 'middle');
    t.setAttribute('font-size', s.size);
    t.setAttribute('fill', s.fill || INK);
    t.style.fontFamily = CSS_FAMILY[s.family] || CSS_FAMILY['Caveat'];
    if (s.letterSpacing) t.setAttribute('letter-spacing', s.letterSpacing);
    if (overlay) overlay.appendChild(t);
    slotEls[s.key] = { el: t, def: s, fitted: s.size };
  });

  // Signature happilystory dans l'aperçu (parité print : signatureSvg worker,
  // Caveat 56, y=3120, opacity .4, encre du design). Masquée si upsell watermark.
  var sigEl = document.createElementNS(SVG_NS, 'text');
  sigEl.setAttribute('x', 1200);
  sigEl.setAttribute('y', 3120);
  sigEl.setAttribute('text-anchor', 'middle');
  sigEl.setAttribute('font-size', 56);
  sigEl.setAttribute('letter-spacing', 10);
  sigEl.setAttribute('opacity', '0.4');
  sigEl.setAttribute('fill', INK);
  sigEl.style.fontFamily = CSS_FAMILY['Caveat'];
  sigEl.textContent = 'happilystory';
  if (overlay) overlay.appendChild(sigEl);

  // Auto-fit : réduit la taille si le texte déborde de slot.maxw (prénoms longs).
  function fitSlot(entry) {
    var el = entry.el, s = entry.def;
    var maxw = Number(s.maxw) || 0;
    el.setAttribute('font-size', s.size);
    entry.fitted = s.size;
    if (maxw) {
      try {
        var w = el.getComputedTextLength();
        if (w > maxw) {
          var next = Math.max(40, Math.floor(s.size * maxw / w));
          el.setAttribute('font-size', next);
          entry.fitted = next;
        }
      } catch (e) { /* getComputedTextLength indispo (élément caché) : garde size */ }
    }
    // Recentrage optique une fois la taille finale connue.
    entry.dx = opticalDx(s.family || 'Caveat', entry.fitted);
    el.setAttribute('x', s.x + entry.dx);
  }

  // ---------- Champs -> valeurs formatées ----------
  var inputs = {
    prenom: form.querySelector('[data-source="prenom"]'),
    datecourte: form.querySelector('[data-source="datecourte"]'),
    heure: form.querySelector('[data-source="heure"]'),
    taille: form.querySelector('[data-source="taille"]'),
    poids: form.querySelector('[data-source="poids"]'),
    lieu: form.querySelector('[data-source="lieu"]')
  };

  // Champ Lieu : visible uniquement si le design déclare un slot "lieu".
  var lieuField = form.querySelector('[data-lieu-field]');
  if (lieuField && N.slots.some(function (s) { return s.key === 'lieu'; })) lieuField.hidden = false;

  function fmtDateCourte(val) { // input date "2025-03-12" -> "12.03.2025"
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val || '');
    return m ? (m[3] + '.' + m[2] + '.' + m[1]) : '';
  }
  function fmtHeure(val) { // input time "08:42" -> "08h42"
    var m = /^(\d{2}):(\d{2})$/.exec(val || '');
    return m ? (m[1] + 'h' + m[2]) : '';
  }
  function fmtTaille(val) { // "51" / "51,5" -> "51 cm" ; laisse tel quel si unité déjà là
    var v = (val || '').trim();
    if (!v) return '';
    if (/cm\s*$/i.test(v)) return v;
    return v + ' cm';
  }
  function fmtPoids(val) { // "3,240" -> "3,240 kg"
    var v = (val || '').trim();
    if (!v) return '';
    if (/(kg|g)\s*$/i.test(v)) return v;
    return v + ' kg';
  }

  // Signe astrologique DÉRIVÉ de la date de naissance (aucun champ client à
  // saisir). Chaque entrée = [mois, jour, signe] : une date STRICTEMENT
  // ANTÉRIEURE à (mois, jour) porte ce signe. La dernière entrée (12, 32)
  // couvre la fin décembre, qui repasse en Capricorne. Bornes usuelles FR.
  var ZODIAC = [
    [1, 20, 'Capricorne'], [2, 19, 'Verseau'], [3, 21, 'Poissons'], [4, 20, 'Bélier'],
    [5, 21, 'Taureau'], [6, 21, 'Gémeaux'], [7, 23, 'Cancer'], [8, 23, 'Lion'],
    [9, 23, 'Vierge'], [10, 23, 'Balance'], [11, 22, 'Scorpion'], [12, 22, 'Sagittaire'],
    [12, 32, 'Capricorne']
  ];
  function signeFromDate(val) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(val || '');
    if (!m) return '';
    var mo = +m[2], d = +m[3];
    for (var i = 0; i < ZODIAC.length; i++) {
      if (mo < ZODIAC[i][0] || (mo === ZODIAC[i][0] && d < ZODIAC[i][1])) return ZODIAC[i][2];
    }
    return 'Capricorne';
  }

  function slotValue(key) {
    if (key === 'prenom') return (inputs.prenom && inputs.prenom.value.trim()) || '';
    if (key === 'datecourte') return fmtDateCourte(inputs.datecourte && inputs.datecourte.value);
    if (key === 'heure') return fmtHeure(inputs.heure && inputs.heure.value);
    if (key === 'taille') return fmtTaille(inputs.taille && inputs.taille.value);
    if (key === 'poids') return fmtPoids(inputs.poids && inputs.poids.value);
    if (key === 'lieu') return (inputs.lieu && inputs.lieu.value.trim()) || '';
    if (key === 'signe') return signeFromDate(inputs.datecourte && inputs.datecourte.value);
    return '';
  }

  // Rendu live : valeur réelle (encre du slot) ou exemple estompé si champ vide.
  function render() {
    N.slots.forEach(function (s) {
      var entry = slotEls[s.key];
      if (!entry) return;
      var v = slotValue(s.key);
      var sample = (s.key === 'prenom') ? samplePrenom : (s.sample || SAMPLE[s.key] || '');
      entry.el.textContent = v || sample;
      entry.el.setAttribute('fill', v ? (s.fill || INK) : lightenHex(s.fill || INK, 0.45));
      fitSlot(entry);
    });
  }
  ['input', 'change'].forEach(function (ev) {
    Object.keys(inputs).forEach(function (k) {
      if (inputs[k]) inputs[k].addEventListener(ev, render);
    });
  });
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { render(); }); }

  // ---------- Palette (canvas + fond couplés) ----------
  var baseImg = root.querySelector('.hsp-product-base');
  var bgLayer = root.querySelector('[data-bg-layer]');
  var canvasWrap = root.querySelector('[data-canvaspick]');
  var swWrap = canvasWrap ? canvasWrap.querySelector('.hsp-canvas-swatches') : null;

  function applyPalette() {
    var pal = PALETTES[curPalette];
    if (!pal) return;
    if (bgLayer) bgLayer.style.background = pal.bg;
    // Encre de signature par palette (fonds sombres -> crème), défaut = ink du design.
    if (sigEl) sigEl.setAttribute('fill', pal.ink || INK);
    if (baseImg && CANVAS_BY_PALETTE[curPalette]) baseImg.src = CANVAS_BY_PALETTE[curPalette];
    if (swWrap) {
      swWrap.querySelectorAll('.hsp-canvas-swatch').forEach(function (b) {
        var on = b.getAttribute('data-pal') === curPalette;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
  }
  function selectPalette(id) {
    if (!PALETTES[id] || !CANVAS_BY_PALETTE[id]) return;
    curPalette = id;
    applyPalette();
  }
  (function buildPaletteSwatches() {
    if (!swWrap || !canvasWrap) return;
    var usable = (N.palettes || []).filter(function (p) { return CANVAS_BY_PALETTE[p.id]; });
    if (usable.length < 2) { applyPalette(); return; }
    usable.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hsp-swatch hsp-canvas-swatch';
      b.setAttribute('data-pal', p.id);
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('title', p.label);
      b.setAttribute('aria-label', p.label);
      b.style.setProperty('--cs', p.bg);
      b.addEventListener('click', function () { selectPalette(p.id); });
      swWrap.appendChild(b);
    });
    canvasWrap.hidden = false;
    applyPalette();
  })();

  // ---------- Toggle garçon / fille ----------
  var genderInput = form.querySelector('[data-gender-input]');
  var genderBtns = form.querySelectorAll('.hsp-gender-btn');
  var gender = '';
  genderBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      gender = btn.getAttribute('data-gender-value') || '';
      genderBtns.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (genderInput) genderInput.value = gender === 'fille' ? 'Une fille' : 'Un garçon';
      var g = (N.genders || {})[gender === 'fille' ? 'fille' : 'garcon'] || {};
      if (g.prenom) {
        samplePrenom = g.prenom;
        if (inputs.prenom) inputs.prenom.placeholder = 'Ex. ' + g.prenom;
      }
      if (g.palette) selectPalette(g.palette);
      render();
    });
  });

  // ---------- Variantes (Format x Cadre) ----------
  var hiddenVariant = form.querySelector('[data-variant-id]');
  var priceNowEl    = root.querySelector('[data-price-now]');
  var btnTotalEl    = form.querySelector('[data-btn-total]');
  var addBtn        = form.querySelector('.hsp-add-to-cart');

  // ---------- Toggle : retirer la signature happilystory ----------
  var noWatermark = false;
  var watermarkBtn = form.querySelector('[data-watermark-btn]');
  function applyWatermark() {
    if (sigEl) sigEl.style.display = noWatermark ? 'none' : '';
    if (watermarkBtn) watermarkBtn.setAttribute('aria-pressed', noWatermark ? 'true' : 'false');
  }
  if (watermarkBtn) {
    watermarkBtn.addEventListener('click', function () {
      noWatermark = !noWatermark;
      applyWatermark();
      updateTotal();
    });
  }

  var sel = { 1: null, 2: null };
  form.querySelectorAll('.hsp-chip.is-active').forEach(function (chip) {
    sel[chip.getAttribute('data-opt')] = chip.getAttribute('data-value');
  });
  var lastPaperFormat = sel['1'];

  var frameEl = root.querySelector('[data-frame]');
  function cadreToState(label) {
    var v = (label || '').toLowerCase();
    if (v.indexOf('noir') !== -1) return 'noir';
    if (v.indexOf('bois') !== -1) return 'bois';
    return 'none';
  }
  function applyFrame() {
    if (frameEl) frameEl.setAttribute('data-cadre', window.hsDigitalMode ? 'none' : cadreToState(sel['2']));
  }
  applyFrame();

  var variantId = CFG.variantId;
  var variantPriceCents = CFG.variantPriceCents;

  var DIGITAL = window.HAPPILYSTORY_DIGITAL || null;
  var digitalChip = form.querySelector('[data-digital-chip]');
  if (DIGITAL && digitalChip) digitalChip.hidden = false;
  function isDigitalMode() { return sel['1'] === '__digital__'; }
  function applyDigitalUi() {
    window.hsDigitalMode = isDigitalMode();
    var cadreGroup = form.querySelector('.hsp-variant-group[data-option-index="2"]');
    if (cadreGroup) cadreGroup.style.display = window.hsDigitalMode ? 'none' : '';
    applyFrame();
    document.querySelectorAll('.hs-upsell[data-key="digital"], .hs-upsell[data-key="replique"], .hs-upsell[data-key="carte"]').forEach(function (card) {
      card.style.display = window.hsDigitalMode ? 'none' : '';
      if (window.hsDigitalMode && card.classList.contains('is-selected')) {
        card.classList.remove('is-selected');
        card.querySelectorAll('.hs-upsell__pill').forEach(function (p) {
          var isNo = p.getAttribute('data-choice') === 'no';
          p.classList.toggle('is-active', isNo);
          p.setAttribute('aria-pressed', isNo ? 'true' : 'false');
        });
        var ex = card.querySelector('[data-extra-for]');
        if (ex) ex.hidden = true;
      }
    });
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function findVariant() {
    var fmt = sel['1'], cad = sel['2'];
    for (var i = 0; i < VARIANTS.length; i++) {
      var v = VARIANTS[i];
      var okF = (fmt == null) || (v.format === fmt);
      var okC = (cad == null) || (v.cadre === cad);
      if (okF && okC) return v;
    }
    return null;
  }

  function upsellsTotalCents() {
    var sum = 0;
    document.querySelectorAll('.hs-upsell.is-selected').forEach(function (card) {
      var p = parseFloat(card.getAttribute('data-price'));
      if (!isNaN(p)) sum += Math.round(p * 100);
    });
    return sum;
  }

  function updateTotal() {
    var total = variantPriceCents + upsellsTotalCents();
    if (noWatermark) total += WATERMARK_PRICE_CENTS;
    if (btnTotalEl) btnTotalEl.textContent = money(total);
  }

  function applyVariant() {
    if (isDigitalMode() && DIGITAL) {
      variantId = DIGITAL.variantId;
      variantPriceCents = DIGITAL.priceCents;
      if (hiddenVariant) hiddenVariant.value = DIGITAL.variantId;
      if (priceNowEl) priceNowEl.textContent = money(DIGITAL.priceCents);
      updateTotal();
      return;
    }
    var v = findVariant();
    if (v) {
      variantId = v.id;
      variantPriceCents = v.price;
      if (hiddenVariant) hiddenVariant.value = v.id;
      if (priceNowEl) priceNowEl.textContent = money(v.price);
    }
    updateTotal();
  }

  // Sous-prix des puces : prix TOTAL de la variante croisée (pattern sportsndeco).
  function refreshChipPrices() {
    form.querySelectorAll('.hsp-chip').forEach(function (chip) {
      var priceEl = chip.querySelector('.hsp-chip__price');
      if (!priceEl) return;
      var val = chip.getAttribute('data-value');
      if (val === '__digital__') {
        if (DIGITAL) priceEl.textContent = money(DIGITAL.priceCents);
        return;
      }
      var isFormat = chip.getAttribute('data-opt') === '1';
      var fmt = isFormat ? val : (lastPaperFormat || sel['1']);
      var cad = isFormat ? sel['2'] : val;
      for (var i = 0; i < VARIANTS.length; i++) {
        var v = VARIANTS[i];
        if ((fmt == null || v.format === fmt) && (cad == null || v.cadre === cad)) {
          priceEl.textContent = money(v.price);
          return;
        }
      }
    });
  }

  form.querySelectorAll('.hsp-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var opt = chip.getAttribute('data-opt');
      var val = chip.getAttribute('data-value');
      sel[opt] = val;
      if (opt === '1' && val !== '__digital__') lastPaperFormat = val;
      chip.closest('.hsp-chips').querySelectorAll('.hsp-chip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      applyVariant();
      refreshChipPrices();
      if (opt === '1') applyDigitalUi();
      if (opt === '2') applyFrame();
    });
  });
  refreshChipPrices();

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.hs-upsell__pill')) {
      setTimeout(updateTotal, 0);
    }
  });

  applyWatermark();
  updateTotal();
  render();

  // ---------- Submit ----------
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    if (!inputs.prenom || !inputs.prenom.value.trim()) {
      if (inputs.prenom) inputs.prenom.focus();
      form.classList.add('hsp-form--invalid');
      return;
    }
    form.classList.remove('hsp-form--invalid');
    render(); // fit final avant capture des sizes

    var v = findVariant();
    var pal = PALETTES[curPalette] || {};

    // ---------- Properties visibles client ----------
    var properties = {};
    properties['Prénom'] = slotValue('prenom');
    var visibles = { datecourte: 'Date de naissance', heure: 'Heure', taille: 'Taille', poids: 'Poids', lieu: 'Lieu de naissance', signe: 'Signe astrologique' };
    Object.keys(visibles).forEach(function (k) {
      var val = slotValue(k);
      if (val) properties[visibles[k]] = val;
    });
    if (gender) properties['Sexe'] = gender === 'fille' ? 'Une fille' : 'Un garçon';
    if (pal.label) properties['Couleur'] = pal.label;

    // ---------- Properties cachées pour le Worker print ----------
    // _hs_grid = les slots renseignés uniquement (un support vide reste vide).
    var gridItems = [];
    N.slots.forEach(function (s) {
      var val = slotValue(s.key);
      if (!val) return;
      var entry = slotEls[s.key];
      gridItems.push({
        x: s.x + ((entry && entry.dx) || 0), y: s.y,
        size: (entry && entry.fitted) || s.size,
        text: val,
        anchor: s.anchor || 'middle',
        family: s.family || 'Caveat',
        fill: s.fill || INK
      });
    });

    properties['_hs_mode']       = 'grid';
    properties['_hs_canvas_url'] = CANVAS_BY_PALETTE[curPalette] || '';
    properties['_hs_bg']         = pal.bg || '#FBF6EE';
    properties['_hs_ink']        = pal.ink || INK;
    properties['_hs_grid']       = JSON.stringify(gridItems);
    properties['_hs_sig_y']      = 3120; // zone signature des designs naissance
    properties['_hs_format']     = (v && v.format) || sel['1'] || '';
    properties['_hs_cadre']      = (v && v.cadre)  || sel['2'] || '';
    if (isDigitalMode() && DIGITAL) {
      properties['_hs_format'] = 'numerique';
      properties['_hs_cadre']  = 'sans';
      properties['Format']     = 'Fichier numérique HD';
      properties['Modèle']     = CFG.productTitle || document.title;
    }

    if (noWatermark) {
      properties['_hs_nowatermark'] = 'true';
      properties['Sans mention happilystory'] = 'Oui';
    }

    var _hsGrp = (typeof window.hsNewGroupToken === 'function') ? window.hsNewGroupToken() : null;
    if (_hsGrp) properties['_hs_group'] = _hsGrp;
    var mainItem = { id: variantId, quantity: 1, properties: properties };
    var items = [mainItem];
    if (typeof window.hsCollectUpsells === 'function') {
      items = items.concat(window.hsCollectUpsells(_hsGrp));
    }
    if (noWatermark && WATERMARK_VARIANT_ID) {
      items.push({ id: WATERMARK_VARIANT_ID, quantity: 1, properties: { _hs_for: 'watermark' } });
    }

    if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d && d.description || 'Erreur panier'); });
        return r.json();
      })
      .then(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        if (window.snRefreshCartDrawer && window.snOpenCartDrawer) {
          Promise.resolve(window.snRefreshCartDrawer()).then(function () { window.snOpenCartDrawer(); });
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
        form.classList.add('hsp-form--invalid');
        if (window.console) console.error('[happilystory] add to cart failed:', err);
        alert('Désolé, l\'ajout au panier a échoué. Merci de réessayer.');
      });
  });
})();
